// extracted by mini-css-extract-plugin
export default {"ModelLoader":"ModelLoader_ModelLoader__XbZGF"};